<template lang="pug">
	.upload-amazon-s3(v-if="showed && Version.SelectedVersion")
		.card(:style="{height: `${{idle: preview ? 730 : 510, preparing: 200, release: 200, uploading: 200, result: preview ? 530 : 420}[state] || 510}px`}")
			.card-header
				i.fa.fa-edit
				span Amazon S3 upload
			.card-body.collapse.show(v-if="state === 'idle'")
				.form-horizontal
					.form-group
						label.col-form-label(for="project-folder") Project folder
							.controls
								input.form-control(id="project-folder" size="16" type="text" v-model="projectFolder")
						label.col-form-label(for="version-folder") Version folder
							.controls
								input.form-control(id="version-folder" size="16" type="text" v-model="versionFolder")
						.two-setting-panel
							.setting-one
								label.col-form-label(for="region") Amazon region
									.controls
										input.form-control.region(id="region" size="16" type="text" v-model="region")
							.setting-two
								label.col-form-label Release type
									.controls.input-group(v-pseudo-modal-show="'release-type-dropdown'")
										span.form-control.release-type(v-if="!multipleUploadAmazonS3Allowed || (multipleUploadAmazonS3Allowed && selectedNetworks.length === 1)") {{releaseType}}
										span.form-control.release-type(v-else) {{selectedNetworks.length + ' releases'}}
										.input-group-append
											span.input-group-text
												i.fa.fa-angle-down
									.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'release-type-dropdown'" :class="{'multiple-upload': Project.SelectedProject.type === 'playable' && multipleUploadAmazonS3Allowed}")
										.dropdown-header(class="text-center")
											strong Choose release type
											span.multiple-upload-switch(v-if="isShowMultipleUploadAmazonS3()" v-b-tooltip.hover="{title: 'Enable multiple upload'}" @click.stop.prevent="switchMultipleUploadAmazonS3")
												.switch-control
													label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
														input.switch-input.form-check-input(type="checkbox" :checked="multipleUploadAmazonS3Allowed")
														span.switch-slider(data-checked="On" data-unchecked="Off")
														span.switch-handle
										NetworkList(:callback="chooseReleaseType" scope="upload" :multipleAllowed="multipleUploadAmazonS3Allowed" network="amazons3")
						.form-horizontal2(v-if="Project.SelectedProject.type === 'playable'")
							.form-group
								label.col-form-label Include preview
								.controls
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" v-model="preview")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
							.form-group(v-if="preview")
								label.col-form-label Preview start file
								.controls
									input.form-control.preview-file(size="16" type="text" v-model="previewFile")
							.form-group(v-if="preview")
								label.col-form-label Show logo
								.controls
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" v-model="showLogo")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
							.form-group(v-if="preview")
								label.col-form-label Allow rotation and device change
								.controls
									label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
										input.switch-input.form-check-input(type="checkbox" v-model="allowRotation" :disabled="Project.SelectedProject.type === 'banner'")
										span.switch-slider(data-checked="On" data-unchecked="Off")
										span.switch-handle
							.form-group(v-if="preview")
								label.col-form-label Default device proportions
								.controls
									select.custom-select.custom-select-sm(v-model="defaultDevice" :disabled="Project.SelectedProject.type === 'banner'")
										option(:selected="defaultDevice === 'iPhone'" :value="'iPhone'") 16:9 (iPhone)
										option(:selected="defaultDevice === 'iPad'" :value="'iPad'") 4:3 (iPad)
										option(:selected="defaultDevice === 'iPhoneX'" :value="'iPhoneX'") 19.5:9 (iPhoneX)
							.form-group(v-if="preview")
								label.col-form-label Default orientation
								.controls
									select.custom-select.custom-select-sm(v-model="defaultOrientation" :disabled="Project.SelectedProject.type === 'banner'")
										option(:selected="defaultOrientation === 'portrait'" :value="'portrait'") Portrait
										option(:selected="defaultOrientation === 'landscape'" :value="'landscape'") Landscape
					.form-result
						span https://{{Publisher.SelectedPublisher.options['AmazonS3']['bucketName']}}.s3.{{region}}.amazonaws.com/{{rootPath}}{{projectFolder}}/{{versionFolder}}/
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="upload()" :disabled="this.multipleUploadAmazonS3Allowed && this.selectedNetworks < 1")
							i.fa.fa-upload
							| &nbsp;&nbsp;Upload
						button.btn.btn-dark(type="button" v-on:click="hide()") Cancel
			.card-body.collapse.show(v-if="state === 'preparing' || state === 'release' || state === 'uploading'")
				.processing
					.icon.fa.fa-spinner.fa-spin
					.text(v-if="state === 'preparing'") preparing...
					.text(v-if="state === 'release'") creating release...
					.text(v-if="state === 'uploading'") uploading...
			.card-body.collapse.show(v-if="state === 'result'")
				.result
					.text(v-if="result && result.type === 'tag'")
						textarea {{result.data}}
					.text(v-if="result && result.type === 'file-link'")
						a(:href="result.data" target="_blank") {{result.data}}
				.form-horizontal
					.form-result.final(v-if="result.options && result.options.length")
						a(v-for="option in result.options" :href="`https://${Publisher.SelectedPublisher.options['AmazonS3']['bucketName']}.s3.${option.region}.amazonaws.com/${rootPath}${option.projectFolder}/${option.versionFolder}/${option.previewFile}`" target="blank") https://{{Publisher.SelectedPublisher.options['AmazonS3']['bucketName']}}.s3.{{option.region}}.amazonaws.com/{{option.rootPath}}{{option.projectFolder}}/{{option.versionFolder}}/{{option.previewFile}}
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="copy()")
							i.fa.fa-copy
							| &nbsp;&nbsp;Copy
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import changeCase 			from "change-case"

	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'
	import { Project } 			from './../../services/Project'
	import { Settings } 		from './../../services/Settings'
	import { Layout } 			from './../../services/Layout'
	import { Version }			from './../../services/Version'
	import { User } 			from "./../../services/User"
	import { Server } 			from "./../../services/Server"

	import NetworkList 			from './../Templates/NetworksList'

	export default {
		name: "UploadAmazonS3",
		mixins: [Screen],
		screen: {
			updateOn: ["Multiple Upload Amazon S3 Networks Changed"],
			events: {

				"Amazon S3 upload Progress": function(data) {

					if (data.AmazonS3UploadProjectId === Project.SelectedProject.id && data.AmazonS3UploadVersionId === Version.SelectedVersion.id) {

						this.state = data.AmazonS3UploadProgress;

						if (data.AmazonS3UploadResult) {
							this.result = data.AmazonS3UploadResult;

							if (this.result.type === 'tag') this.result.data = this.result.data.replaceAll('${path_macro}', (Publisher.SelectedPublisher.options['AmazonS3']['cdnUrl'] || ('https://' + Publisher.SelectedPublisher.options['AmazonS3']['bucketName'] + '.s3.' + this.region + '.amazonaws.com/')) + this.rootPath + this.projectFolder + '/' + this.versionFolder + '/');

							if (data.AmazonS3UploadResult.options && data.AmazonS3UploadResult.options.length) {
								this.result.options = data.AmazonS3UploadResult.options.filter(option => option && option.preview);
							}
						}

					}

				}
			}
		},
		components: {
			NetworkList
		},
		data() {

			this.Publisher = Publisher;
			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			return {
				state: 'idle', //'preparing', 'release', 'uploading', 'result'
				multipleUploadAmazonS3Allowed: false,
				selectedNetworks: 0,
				projectFolder: '',
				versionFolder: '',
				rootPath: '',
				releaseType: 'mraid',
				region: 'eu-central-1',
				preview: false,
				previewFile: 'preview.html',
				showLogo: true,
				allowRotation: true,
				defaultDevice: 'iPhone',
				defaultOrientation: 'portrait',
				result: {}
			};

		},
		computed: {
		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion) return;

				this.rootPath = (Publisher.SelectedPublisher && Publisher.SelectedPublisher.options['AmazonS3'] && Publisher.SelectedPublisher.options['AmazonS3']['RootPath']) ? Publisher.SelectedPublisher.options['AmazonS3']['RootPath'] : '';
				this.projectFolder = Project.SelectedProject ? Project.SelectedProject.codename : '';
				this.versionFolder = changeCase.paramCase(Version.SelectedVersion.title + '-' + Version.SelectedVersion.codename) + '-' + this.releaseType;
				this.region = Publisher.SelectedPublisher ? Publisher.SelectedPublisher.options['AmazonS3']['bucketRegion'] : 'eu-central-1';
				this.preview = Project.SelectedProject.type === 'playable' && !!(Publisher.SelectedPublisher && Publisher.SelectedPublisher.options['AmazonS3'] && Publisher.SelectedPublisher.options['AmazonS3']['preview']);

				if (this.preview) {
					this.previewFile = ('previewFile' in Publisher.SelectedPublisher.options['AmazonS3']['preview']) ? Publisher.SelectedPublisher.options['AmazonS3']['preview']['previewFile'] : 'preview.html';
					this.showLogo = ('showLogo' in Publisher.SelectedPublisher.options['AmazonS3']['preview']) ? Publisher.SelectedPublisher.options['AmazonS3']['preview']['showLogo'] : true;
					this.allowRotation = ('allowRotation' in Publisher.SelectedPublisher.options['AmazonS3']['preview']) ? Publisher.SelectedPublisher.options['AmazonS3']['preview']['allowRotation'] : true;
					this.defaultDevice = ('defaultDevice' in Publisher.SelectedPublisher.options['AmazonS3']['preview']) ? Publisher.SelectedPublisher.options['AmazonS3']['preview']['defaultDevice'] : 'iPhone';
					this.defaultOrientation = ('defaultOrientation' in Publisher.SelectedPublisher.options['AmazonS3']['preview']) ? Publisher.SelectedPublisher.options['AmazonS3']['preview']['defaultOrientation'] : 'portrait';
				}

				if (Publisher.SelectedPublisher && this.projectFolder.indexOf(Publisher.SelectedPublisher.codename) === 0) this.projectFolder = this.projectFolder.substr(Publisher.SelectedPublisher.codename.length + 1);

				this.multipleUploadAmazonS3Allowed = User.currentUser?.options?.features?.multipleUploadAmazonS3 && this.isShowMultipleUploadAmazonS3();

				this.selectedNetworks = this.getSelectedReleasesForUpload();

				this.updateVersionFolder();

			},
			upload() {

				let releasesTypes = [];
				if (this.multipleUploadAmazonS3Allowed && this.selectedNetworks.length) releasesTypes = this.selectedNetworks;
				else releasesTypes = [this.releaseType];

				const versionFolder = changeCase.paramCase(this.versionFolder.replace('{network-name}', ''));

				Server.sendToSocket({
					AmazonS3Upload: {
						projectId: Project.SelectedProject.id,
						versionId: Version.SelectedVersion.id,
						releasesTypes: releasesTypes,
						projectFolder: this.projectFolder,
						versionFolder: versionFolder,
						preview: this.preview,
						name: this.projectFolder + '-' + versionFolder, // К этому имени идет привязка параметров превью в localStorage
						previewFile: this.previewFile,
						showLogo: this.showLogo,
						allowRotation: this.allowRotation,
						defaultDevice: this.defaultDevice,
						defaultOrientation: this.defaultOrientation,
						region: this.region
					}
				});

				this.state = 'processing';

			},
			chooseReleaseType(type) {

				this.releaseType = type;

				this.versionFolder = changeCase.paramCase(Version.SelectedVersion.title + '-' + Version.SelectedVersion.codename) + '-' + this.releaseType;

				Broadcast.call("Pseudo Modal Hide", ['release-type-dropdown']);

			},
			copy() {

				let text = '';

				if (this.result) text = this.result.data;

				Layout.copyTextToClipboard(text);

			},
			close() {

				this.state = 'idle';

				this.hide();

			},

			getSelectedReleasesForUpload() {

				let releases = Object.keys(User.currentUser?.options?.features?.multipleUploadAmazonS3Networks || {}).filter(release => Settings.isReleaseAvailable(release, this.multipleUploadAmazonS3Allowed, 'upload'));

				if (releases.length === 1 && this.multipleUploadAmazonS3Allowed) this.releaseType = releases[0];

				return releases;

			},

			updateVersionFolder() {

				if (!this.multipleUploadAmazonS3Allowed) this.versionFolder = changeCase.paramCase(Version.SelectedVersion.title + '-' + Version.SelectedVersion.codename) + '-' + this.releaseType;
				else {
					if (!this.selectedNetworks.length) this.versionFolder = '';
					else if (this.selectedNetworks.length === 1) this.versionFolder = changeCase.paramCase(Version.SelectedVersion.title + '-' + Version.SelectedVersion.codename) + '-' + this.selectedNetworks[0];
					else this.versionFolder = changeCase.paramCase(Version.SelectedVersion.title + '-' + Version.SelectedVersion.codename) + '-{network-name}';
				}

			},

			switchMultipleUploadAmazonS3() {

				if (event.target.classList.contains('switch-input')) return;
				this.multipleUploadAmazonS3Allowed = !this.multipleUploadAmazonS3Allowed;
				User.toggleFeature(User.currentUser.id, 'multipleUploadAmazonS3', this.multipleUploadAmazonS3Allowed);

				this.updateVersionFolder();

			},

			isShowMultipleUploadAmazonS3() {

				let show = true;

				if (Project.SelectedProject.type !== 'playable') show = false;

				if (Publisher.SelectedPublisher && Publisher.SelectedPublisher.options) {

					let releaseNames = Publisher.SelectedPublisher.options.ReleaseNames;

					if (releaseNames === 'version-names-only' || releaseNames === 'use-title') show = false;

				}

				return show;

			}
		}
	}
</script>


<style lang="sass">

	.upload-amazon-s3
		position: absolute
		z-index: 1020
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 530px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

				.btn.btn-primary:disabled
					cursor: not-allowed

			.form-control.release-type
				cursor: pointer
				width: 175px
				margin-top: 5px
				user-select: none
				white-space: nowrap
				overflow: hidden
				text-overflow: ellipsis

			.input-group-append
				margin-top: 5px
				cursor: pointer

				.input-group-text
					background-color: #343b41
					border: 1px solid #23282c
					color: #e4e7ea

		.two-setting-panel
			display: flex
			flex-direction: row
			justify-content: space-between

			.form-control.region
				width: 200px

			.col-form-label
				white-space: nowrap

			&.preview
				height: 65px

				.switch-label
					margin-top: 4px

		.form-horizontal2
			display: flex
			flex-direction: column
			margin-top: 20px
			border-top: 1px solid #23282c
			border-bottom: 1px solid #23282c
			padding-top: 10px
			padding-bottom: 3px

			.form-group
				display: flex
				flex-direction: row
				justify-content: space-between
				align-items: center
				margin-bottom: 0.5rem

			.form-actions
				margin-top: 1.5rem

			.preview-file
				width: 209px
				margin-top: 0

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

		.form-result
			color: #20a8d8
			font-size: 11px
			border-bottom: 1px solid #23282c
			padding-bottom: 15px

			&.final
				border-top: 1px solid #23282c
				margin-top: 20px
				padding-top: 15px
				display: flex
				flex-direction: column
				gap: 10px
				max-height: 100px
				overflow-y: scroll

		.dropdown-menu
			position: absolute
			right: -280px
			top: auto
			bottom: 100px
			display: block
			z-index: 10000
			line-height: 1.5
			width: 300px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

			.dropdown-header
				cursor: default
				display: flex
				flex-direction: row
				justify-content: space-between

				>.multiple-upload-switch
					opacity: 0.3

			.networks
				height: 350px
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 300px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

			&.multiple-upload
				right: -300px
				width: 320px

				>.dropdown-header
					padding: 8px 40px 8px 30px

					>.multiple-upload-switch
						opacity: 1

				.dropdown-item
					width: 320px
					padding-left: 30px

		.processing
			height: 100%
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center

			.icon
				display: inline
				font-size: 30px

		.result

			textarea
				width: 100%
				height: 250px
				background: transparent
				border: none
				color: #fff
				font-size: 12px
				white-space: pre
				overflow-wrap: normal
				overflow-x: auto

		.custom-select
			cursor: pointer
			color: #fff
			width: auto
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74
</style>

